import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-down-right', 'CornerDownRight', [["path",{"d":"M19 13.973H9a4 4 0 0 1-4-4V5m14 8.973-4.78-5.027M19 13.973 14.22 19","key":"svg-0"}]]);